'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M99.9 400L144 444.1 357.1 231 313 186.9 99.9 400z', 'M234.7 42.7L256 0l21.3 42.7L320 64 277.3 85.3 256 128 234.7 85.3 192 64l42.7-21.3zM64 96L96 32l32 64 64 32-64 32L96 224 64 160 0 128 64 96zM448 288l32 64 64 32-64 32-32 64-32-64-64-32 64-32 32-64zM177.9 478.1L144 512l-33.9-33.9L65.9 433.9 32 400l33.9-33.9L398.1 33.9 432 0l33.9 33.9 44.1 44.1L544 112l-33.9 33.9L177.9 478.1zM357.1 231L313 186.9 99.9 400 144 444.1 357.1 231zM391 197.1L476.1 112 432 67.9 346.9 153 391 197.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;